module.exports = __webpack_public_path__ + "img/dfa0b48eef4e5e6f0b4bdcda398f59b9.png";